export class GamePlayerState {
    user_id: string;
    user: any;
    current_tile: number;
    action_date: Date; // time_field
}